import React from 'react';
import HomePage from './pages/HomePage/HomePage.jsx';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LayoutDetail from './components/LayoutDetail/LayoutDetail.jsx';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/layout/:id" element={<LayoutDetail />} />
      </Routes>
    </Router>
  );
}

export default App;